module.exports = __webpack_public_path__ + "img/shiping.d042bdd5.png";